// Detecção de ambiente pelo hostname (runtime).
//
// Por que hostname e não `process.env.REACT_APP_FRONTEND_URL` (build-time):
// `dashboard.infoaccess-mkt.com.br` é a PRODUÇÃO e `sistemateste.infoaccess-mkt.com.br`
// é o ambiente de TESTES (trocados em 10/2026; antes era o contrário). Ambos os
// deploys rodam `yarn build` e o `.env.production` aponta para o dashboard, então
// a var de build não diferencia teste de produção. O hostname sempre reflete o
// domínio real em que o app está rodando — é a checagem confiável.

const getHost = () => (typeof window !== 'undefined' && window.location.hostname) || '';

export const isLocalhost = () => {
    const host = getHost();
    return host === 'localhost' || host === '127.0.0.1';
};

// `sandbox.` (17/10/2026) é o espelho do dashboard nesta branch e se comporta igual a ele.
export const isDashboard = () => getHost().startsWith('dashboard') || getHost().startsWith('sandbox');

// dashboard = PRODUÇÃO
export const isProducao = () => isDashboard();

// sandbox = o ambiente de testes desde 17/10/2026 (branch access-sandbox).
export const isSandbox = () => getHost().startsWith('sandbox');

// Ambiente onde gatilhos de QA podem aparecer: só a sandbox. Na produção real,
// nos ambientes congelados e no localhost, a rota de QA nem existe.
export const isAmbienteTeste = () => isSandbox();
